<template>
  <div>
    <van-popup class="m-con" :close-on-click-overlay="false" v-model="show" ref="popup_container">
      <h2>温馨提示</h2>
      <p>
        您在使用我们商城服务前，请仔细阅读
        <a style="color:red;font-weight: bold" href="http://www.36588.com.cn/tms/xieyi/sjkyxy.html">
          《法律声明及隐私权政策》
        </a>
        处理规则，当您点击同意，即表示您已经理解并同意该条款，该条款将构成对您具有法律约束力的文件。个人信息处理规则主要包含一下内容：个人信息（包括手机号、位置信息等）的收集使用规则及设备权限的调用情况
      </p>
      <van-sticky position="bottom" :offset-bottom="0" :container="container">
        <button class="confirmBtn" @click="agree">同意</button>
        <button class="exitBtn" @click="disAgree">不同意并退出</button>
      </van-sticky>
    </van-popup>
   <van-popup class="m-con" :close-on-click-overlay="false" v-model="showtips" ref="popup_container">
      <h2>个人信息</h2>
      <div>
         <div class="m-user-pop-phonum">
            <van-cell-group v-if="!isHaidilao">
              <van-field
                v-model="newPhone.phone"
                label="手机号"
                placeholder="请输入手机号"
                @input="onChangeNewPhone">
                 <van-button v-if="!isdtbx" class="m-btn-code" slot="button" type="primary" size="small" round @click="onSendVeriCode">
                    发送验证码
                  </van-button>
                <van-button v-show="!veriFlag" class="m-btn-code" slot="button" type="primary" size="small" round>
                  <van-count-down ref="phone" :auto-start="close" @finish="finishVeri" :time="time" />
                </van-button>
              </van-field>
              <div v-if="!newPhone.valid">手机号码格式错误</div>
              <van-field
                v-model="newPhone.veriCode"
                v-if="!isdtbx"
                label="验证码"
                placeholder="请输入验证码"
                maxlength="11">
              </van-field>
              <van-field
                v-model="newPhone.name"
                label="用户名"
                placeholder="用户名"
                maxlength="11">
              </van-field>
               <div v-show="newPhone.namevalid">名称不能为空</div>
            </van-cell-group>
            <van-cell-group v-if="isHaidilao">
              <van-field
                v-model="newPhone.account"
                label="账号"
                placeholder="请输入邮箱"
               >
              </van-field>
              <div v-if="!newPhone.valid">邮箱格式错误</div>
              <van-field
                v-model="newPhone.password"
                type="password"
                label="密码"
                placeholder="密码"
                maxlength="11">
              </van-field>
            </van-cell-group>
          </div>
          <div class="m-popup-footer">
            <van-button
              type="primary"
              size="large"
              round
              @click="onOKNewPhone">确定
            </van-button>
          </div>
      </div>
    </van-popup>
    <van-popup class="m-con" :close-on-click-overlay="false" v-model="showCustomer" ref="popup_container">
          <h2>个人信息</h2>
          <div>
             <div class="m-user-pop-phonum">
                <van-cell-group>
                  <label class="selectSalesLabel">业务员：</label>
                    <select id="selectSales" class="selectSales">
                      <option v-for="item in columns" :value="item.code">{{item.salesMan}}</option>
                    </select>
                 <!-- <van-picker
                  :columns="columns"
                  @cancel="showPicker = false"
                  @confirm="onConfirm"
                  ></van-picker> -->
                <!--  <van-select
                    v-model="customer.salesCode"
                    label="业务员"
                    placeholder="业务员"
                    maxlength="11">

                  </van-select> -->
                   <div v-show="customer.salesCodevalid">业务员不能为空</div>
                </van-cell-group>
                <van-cell-group >
                  <van-field
                    v-model="customer.customerName"
                    label="客户名称"
                    placeholder="客户名称"
                   >
                  </van-field>
                  <div v-if="customer.valid">客户名称错误</div>
                  <van-field
                    v-model="customer.phone"
                    label="电话"
                    placeholder="电话"
                    maxlength="11">
                  </van-field>
                  <div v-if="customer.phoneValid">客户名称错误</div>
                </van-cell-group>
              </div>
              <div class="m-popup-footer">
                <van-button
                  type="primary"
                  size="large"
                  round
                  @click="onSubmitCustomer">确定
                </van-button>
              </div>
          </div>
        </van-popup>
  </div>

</template>

<script>
  import {mapGetters} from 'vuex';
  import GlobalEvent from '@/Event/GlobalEvent.js'
  import {Sticky,Field,CountDown,Toast} from 'vant';
  import {isvalidPhone,validateEmail} from '@/utils/validate';
  import {doFormPost,doJsonPost} from '@/utils/request';
  import store from '@/store/index';
  export default {
    name: "agreementPopup",
    components:{
        [Sticky .name]:Sticky,
        [Field.name]: Field,
        [CountDown.name]: CountDown,
        [Toast.name]: Toast,
    },
    computed: {
        ...mapGetters([
            'storeType',
            'childShopName'
        ]),
    },
    watch: {
        // brandConfig 由 permission.js 异步获取，created 时可能还未就绪
        // 通过 watch 监听，数据到达后再执行品牌判断逻辑
        '$store.state.app.brandConfig': {
            handler(newVal) {
                if (newVal && newVal.shopId) {
                    this.handleBrandConfigReady();
                }
            },
            immediate: true,
        }
    },
    data () {
      return {
        show: false,
        showtips:false,
        key: 'AGREEMENT_POPUP_20220526',
        customer_key: 'CUSTOMER_POPUP_20240318',
        container: null,
        veriFlag: true,
        time: 60000,
        close: false,
        brandConfigReady: false,
        isHaidilao: this.$store.state.app.isHaidilao,
        isdtbx:false,
        showCustomer:false,
        showPicker:true,
        newPhone: {
            phone: '',
            veriCode: '',
            valid: true,
            name:'',
            namevalid:false,
        },
        customer:{
          code:'',
          salesCode:'',
           valid: false,
           phoneValid:false,
          customerName:'',
          phone:'',
        },
         columns: []
      }
    },
    mounted() {

        this.container = this.$refs['popup_container'];
        console.log('agreementPopup', this.storeType)
        if(this.storeType != 'newRetailApplet' && !localStorage.getItem(this.key)){
            doFormPost('/main/getStoreType',null, rs => {
              if (rs.result === 'success') {
                let storeType = rs.userData.storeType;
                if(storeType == 'newRetailApplet'){
                  this.agree()
                }else{
                  this.show = true
                }
              }

            })
        }
        // 益好商城判断已移至 handleBrandConfigReady，由 watch brandConfig 触发

    },
    methods: {
      // brandConfig 就绪后执行品牌判断逻辑（由 watch 触发，替代原 created 钩子）
      handleBrandConfigReady(){
        if(this.brandConfigReady) return; // 防止重复执行
        this.brandConfigReady = true;
        var bc = this.$store.state.app.brandConfig;
        console.log('isHaidilao', bc.isHaidilao);
        // 海底捞：通过后端下发的 brandConfig.isHaidilao 判断
        if(bc.isHaidilao){
           this.show = false
          this.isHaidilao = true;
        }

        // 华莱士/海底捞/薛记炒货：通过后端下发的 brandConfig 判断
        if(localStorage.getItem(this.key)&&(bc.isHls||bc.isHaidilao||bc.isXjch)){
          this.hualaishiUserCheck();
        }

        // 益好商城：通过后端下发的 brandConfig.isYh 判断
        if(!localStorage.getItem(this.customer_key)&&bc.isYh){
          this.showCustomerPop();
        }
      },
      onSubmitCustomer(){
        var selectedValue = document.getElementById("selectSales").value;
        console.info("selectedValue====")
        console.info(selectedValue);
        this.customer.salesCode = selectedValue;
        if(!this.customer.customerName){
          this.customer.valid = true;
          return
        }else{
           this.customer.valid = false;
        }
        if(!this.customer.phone){
          this.customer.phoneValid = true;
          return
        }else{
           this.customer.phoneValid = false;
        }
        var that = this;
        var url = "/sales/addCustomer";
        doJsonPost(url,this.customer, rs => {
          console.info(rs);
          if(rs.result=="success"){
            that.columns = rs.userData;
            that.showCustomer = false;
            localStorage.setItem(that.customer_key,true);
          }

        })
      },
      chooseItem(e){
         console.info("e==========")
        console.info(e)
      },
        showPopup() {
            this.show = true;
        },
        agree(){
            // 大童保险：通过后端下发的 brandConfig.isDtbx 判断
            if(this.$store.state.app.brandConfig.isDtbx){//大童保险，需要填写电话和姓名，但是不再校验
                this.isdtbx=true;
                this.showtips = true;
            }
            this.show = false
             // 大童保险/华莱士/薛记炒货：通过后端下发的 brandConfig 判断
             if(this.$store.state.app.brandConfig.isDtbx||this.$store.state.app.brandConfig.isHls||this.$store.state.app.brandConfig.isXjch){
              this.hualaishiUserCheck();
             }else{
                localStorage.setItem(this.key, true)
             }
             // 益好商城
             if(this.$store.state.app.brandConfig.isYh){
              this.showCustomerPop();
             }
        },
        showCustomerPop(){
          this.showCustomer = true;
          this.getSalesGetList();
        },
        disAgree(){
            // this.show=false;
            console.info("回退一步")
            window.history.go(-1);
        },
        getSalesGetList(){
          var that = this;
          var url = "/sales/getSalesList";
          doJsonPost(url, null, rs => {
            console.info(rs);
            if(rs.result=="success"&&rs.userData){
              that.columns = rs.userData;
            }

          })
        },
        //添加华莱士和保险公司人员权限校验
        hualaishiUserCheck() {
          var that = this;

          var url="";
          if(localStorage.getItem("account")){
            url = '/wechatLogin/checkHuaLaiShiUser' + '?serverNum='+localStorage.getItem("account")
          }else{
             url = '/wechatLogin/checkHuaLaiShiUser'
          }
            doJsonPost(url, null, rs => {

                console.info(rs)
                if (rs.result == 'success') {
                  if(rs.userData && rs.userData.usrUser){
                    if(rs.userData.hualaishiUser==null){
                      that.showtips = true;
                    }else{
                      if(rs.userData.hualaishiUser){
                      var hua = rs.userData.hualaishiUser;
                      localStorage.setItem("maxNum", hua.maxNum)
                      localStorage.setItem("areadyNum", hua.areadyNum)
                      localStorage.setItem("phone", hua.phone)
                      localStorage.setItem("userName", hua.name)
                      localStorage.setItem("hualaishiCode", hua.shopCode)
                      store.dispatch('setUserName', hua.name);
                      store.dispatch('setChildShopName', hua.childShopName);
                      store.dispatch('setChildShopCode', hua.childShopCode);
                      GlobalEvent.create('screenShot').trigger('toDataURLComplete',hua.childShopName);
                       // store.dispatch('setUserName', hua.name);
                       // store.dispatch('setPhone', hua.phone);
                       // store.dispatch('setMaxNum', hua.maxNum);
                       // store.dispatch('setAreadyNum', hua.areadyNum);
                      }
                       store.dispatch('setOpenId', rs.userData.usrUser.wxOpenid);
                      that.showtips = false;
                    }
                  }else{
                    //海底捞兼容邮箱登录：通过后端下发的 brandConfig.isHaidilao 判断
                    if(rs.userData&&that.$store.state.app.brandConfig.isHaidilao){
                      var data = rs.userData;
                      store.dispatch('setChildShopName', data.name);
                      store.dispatch('setChildShopCode', data.code);
                      localStorage.setItem("hualaishiCode", data.code)
                      GlobalEvent.create('screenShot').trigger('toDataURLComplete',data.name);
                    }else{
                     that.showtips = true;
                    }
                  }
                }else{
                  that.showtips = true;
                }
            })
        },
        submitPhone(){
          this.showtips = false;
        },
        finishVeri() {
            this.$refs.phone.reset();
            this.veriFlag=true;
        },
        onChangeNewPhone() {
            this.newPhone.valid = true;
        },
        // 发送验证码
        onSendVeriCode() {
            let that = this;
            if (isvalidPhone(this.newPhone.phone)) {
                this.newPhone.valid = true;
                doFormPost('/userInfo/sendVeriCode', {
                    phone: this.newPhone.phone
                }, rs => {
                    if (rs.result == 'success') {
                        Toast('发送成功');
                        that.$refs.phone.start();
                        that.veriFlag=false;
                    } else {
                      if(rs.result == 'fail' &&rs.message == '手机号已被绑定' ){
                         that.showtips = false;
                      }else{
                        Toast(rs.message);

                      }
                    }
                });
            } else {
                this.newPhone.valid = false;
            }
        },
        // 更改手机号
        onOKNewPhone() {
          var that = this;
          if(this.isHaidilao){
            if(validateEmail(this.newPhone.account)){
               this.newPhone.valid = true;
               doFormPost('/userInfo/validVeriCode', {
                   account: this.newPhone.account,
                   password: this.newPhone.password
               }, rs => {
                   if (rs.result == 'success') {
                     localStorage.setItem("account", that.newPhone.account);
                      localStorage.setItem("password", that.newPhone.password);
                       that.showtips = false;
                       // 海底捞：通过后端下发的 brandConfig.isHaidilao 判断
                       if(that.$store.state.app.brandConfig.isHaidilao){
                         that. hualaishiUserCheck();
                       }
                   } else {
                       //Toast(rs.message);
                       localStorage.removeItem(that.key)
                       Toast("您不是指定用户，不能下单");
                   }
               });
            }else{

               this.newPhone.valid = false;
            }
          }else if(this.isdtbx){//大童保险只校验手机号和姓名
            if (isvalidPhone(this.newPhone.phone)) {
                  this.newPhone.valid = true;
                }else{
                  this.newPhone.valid = false;
                  return;
                }
            if(this.newPhone.name){
             this.newPhone.namevalid = false;
            }else{
              this.newPhone.namevalid = true;
            }
            localStorage.setItem("phone", this.newPhone.phone)
            localStorage.setItem("userName", this.newPhone.name)
             that.showtips = false;
          }else{
            if (isvalidPhone(this.newPhone.phone)) {
                this.newPhone.valid = true;
                doFormPost('/userInfo/validVeriCode', {
                    phone: this.newPhone.phone,
                    veriCode: this.newPhone.veriCode,
                    name: this.newPhone.name
                }, rs => {
                    if (rs.result == 'success') {
                      localStorage.setItem(that.key, true)
                        that.showtips = false;
                    } else {
                        //Toast(rs.message);
                        localStorage.removeItem(that.key)
                        Toast("您不是指定用户，不能下单");
                    }
                });
            } else {
                this.newPhone.valid = false;
            }
          }
        },
    },
  }
</script>
<style scoped >
.m-con{
  width: 80%;
  padding: 12px 24px;
  border-radius: 8px;
  /* height: 80%; */
}
.m-con h2{
    text-align: center;
    font-size: 20px;
    color: #303133;
    margin: 16px 0;
}
.confirmBtn{
  display: block;
  width: 90%;
  padding: 12px;
  text-align: center;
  border-radius: 20px;
  color: #fff;
  background-color: #EF4056;
  border: 0;
  margin: 24px auto 8px auto;
}
.exitBtn{
  display: block;
  width: 90%;
  padding: 12px;
  text-align: center;
  border-radius: 20px;
  color: #606266;
  background-color: transparent;
  border: 0;
  margin: 12px auto 8px auto;
  text-decoration: underline;
}
.selectSales{
  width: 75%;
  border: 1px solid #ddd;
  height: 30px;
}
.selectSalesLabel{
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/agreementPopup.vue